import { NavigationMockApi } from 'app/mock-api/common/navigation/api';

export const mockApiServices = [NavigationMockApi];
